import Component from '../Component';
import Block from './Block';
import childrenLokalityData from './childrenData/lokality';
import SearchButton from '../ControlButtonGroup/SearchButton';

class Layers extends Component {
    constructor(props) {
        super(props);

        this.searchButton = new SearchButton();

        this.lokalityBlock = new Block({
            blockClassName: 'js-layers-filterable',
            headingText: 'Lokality',
            controlClassName: 'js-layers-markers',
        });
    }

    componentDidMount() {
        this.searchButton.setRefs(this.refs);
        this.searchButton.componentDidMount();

        this.lokalityBlock.setRefs(this.refs);
        this.lokalityBlock.componentDidMount();
    }

    toggleActive() {
        this.refs['content-layers'].classList.toggle('active');
    }

    render() {
        return (`
            <div ref="content-layers" class="layerPanel__content--layers active scroll">
                ${this.searchButton.render()}
                ${this.lokalityBlock.setChildren(childrenLokalityData).render()}
            </div>`
        );
    }
}

export default Layers;
